import { render, staticRenderFns } from "./statementListIng.vue?vue&type=template&id=28faa472"
import script from "./statementListIng.vue?vue&type=script&lang=js"
export * from "./statementListIng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports